import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Skill } from './skill';

export interface SkillsCollection {
  getSkills(): Observable<Skill[]>;
  addSkill(skill: Skill): Promise<unknown>;
  editSkill(skill: Skill): Promise<void>;
  deleteSkill(skill: Skill): Promise<void>;
}

export const SKILLS_COLLECTION = new InjectionToken<SkillsCollection>(
  'SKILLS_COLLECTION',
);
